export const AUTH_TOKEN: string = "AUTH_TOKEN";
